import { PText } from "@porsche-design-system/components-react"
import type { InventoryAndIntakeChange } from "@slfinrtl/ui-bff-routes"
import { stockStatusMessages, vehicleTypeMessages } from "@slfinrtl/ui-bff-routes"
import { FormattedMessage } from "react-intl"
import { inventoryAndIntakeFieldMessages } from "src/components"
import { FieldWrapper } from "../FieldWrapper"

export interface InventoryAndIntakeChangeView {
	inventoryAndIntake?: InventoryAndIntakeChange
}

export interface InventoryAndIntakeChangesProps {
	view: InventoryAndIntakeChangeView
}

export const InventoryAndIntakeChanges = ({ view }: InventoryAndIntakeChangesProps) => {
	const { inventoryAndIntake } = view
	return (
		<>
			{inventoryAndIntake?.vehicleType && (
				<FieldWrapper>
					<PText>
						<FormattedMessage {...inventoryAndIntakeFieldMessages.vehicleTypeLabel} />
					</PText>
					<PText>
						<FormattedMessage {...vehicleTypeMessages[inventoryAndIntake.vehicleType]} />
					</PText>
				</FieldWrapper>
			)}
			{inventoryAndIntake?.stockStatus && (
				<FieldWrapper>
					<PText>
						<FormattedMessage {...inventoryAndIntakeFieldMessages.stockStatusLabel} />
					</PText>
					<PText>
						<FormattedMessage {...stockStatusMessages[inventoryAndIntake.stockStatus]} />
					</PText>
				</FieldWrapper>
			)}
		</>
	)
}
